import { render, staticRenderFns } from "./projectWorkflow.vue?vue&type=template&id=09b18072&scoped=true"
import script from "./projectWorkflow.vue?vue&type=script&lang=js"
export * from "./projectWorkflow.vue?vue&type=script&lang=js"
import style0 from "./projectWorkflow.vue?vue&type=style&index=0&id=09b18072&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b18072",
  null
  
)

export default component.exports